import { supabase } from "@/integrations/supabase/client";

const KEY = "pending_invitation_token";
const TOKEN_RE = /^[0-9a-f-]{36}$/i;

export function savePendingInvitationToken(token: string | null | undefined) {
  if (!token || !TOKEN_RE.test(token)) return;
  try { localStorage.setItem(KEY, token); } catch { /* ignore */ }
}

export function getPendingInvitationToken(metadataToken?: unknown): string | null {
  let local: string | null = null;
  try { local = localStorage.getItem(KEY); } catch { /* ignore */ }
  if (local && TOKEN_RE.test(local)) return local;
  if (typeof metadataToken === "string" && TOKEN_RE.test(metadataToken)) return metadataToken;
  return null;
}

export async function clearPendingInvitationToken() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  const { data } = await supabase.auth.getUser();
  if (data.user?.user_metadata?.pending_invite_token) {
    await supabase.auth.updateUser({ data: { pending_invite_token: null } });
  }
}
